import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';
import type { CodeReviewAction } from '../../interface/transactionCodes';
import {
  CARD_BG,
  CODE_ACTION_FONT_SIZE,
  CODE_ACTION_GHOST_INK,
  CODE_ACTION_H,
  CODE_ACTION_INERT_OPACITY,
  CODE_ACTION_KBD_BG,
  CODE_ACTION_KBD_SIZE,
  CODE_ACTION_PAD,
  CODE_ACTION_RADIUS,
  CODE_ACTION_REJECT_BORDER,
  CODE_ACTION_REJECT_INK,
  CODE_ACTIONS_GAP,
  CODE_ACTIONS_PAD,
  INK,
  INK_MUTED,
  MONO_STACK
} from '../../styles/tokens';

const ACTIONS = [
  { action: 'accept', key: 'A', label: 'Accept', bg: INK, color: CARD_BG, border: INK },
  { action: 'replace', key: 'R', label: 'Replace', bg: CARD_BG, color: CODE_ACTION_GHOST_INK, border: 'transparent' },
  { action: 'decline', key: 'D', label: 'Decline', bg: CARD_BG, color: CODE_ACTION_REJECT_INK, border: CODE_ACTION_REJECT_BORDER }
] as const;

export const CodeActions: React.FC<{
  readonly id?: string;
  readonly onAction?: (action: CodeReviewAction) => void;
  readonly hint?: CodeReviewAction;
}> = ({ id, onAction, hint }) => (
  <Flex id={id} role="group" aria-label="Review actions" gap={CODE_ACTIONS_GAP} p={CODE_ACTIONS_PAD} data-testid="code-actions">
    {ACTIONS.map(({ action, key, label, bg, color, border }) => (
      <Tooltip key={label} label={label + ' will be added in a later release'} placement="top" openDelay={300}>
        <Box
          as="button"
          type="button"
          aria-label={label}
          aria-disabled="true"
          onClick={(event: React.MouseEvent) => {
            event.preventDefault();
            onAction?.(action);
          }}
          display="inline-flex"
          alignItems="center"
          gap="5px"
          h={CODE_ACTION_H}
          p={CODE_ACTION_PAD}
          borderRadius={CODE_ACTION_RADIUS}
          border="1px solid"
          borderColor={border}
          bg={bg}
          color={color}
          fontSize={CODE_ACTION_FONT_SIZE}
          fontWeight={600}
          opacity={CODE_ACTION_INERT_OPACITY}
          cursor="not-allowed"
        >
          <Box as="span" aria-hidden="true" fontFamily={MONO_STACK} fontSize={CODE_ACTION_KBD_SIZE} px="3px" borderRadius="3px" bg={CODE_ACTION_KBD_BG} minW="14px" textAlign="center">
            {key}
          </Box>
          {label}
        </Box>
      </Tooltip>
    ))}
    <Text role="status" fontSize="11px" color={INK_MUTED}>
      {hint ? `${ACTIONS.find(({ action }) => action === hint)?.label} will be added in a later release` : ''}
    </Text>
  </Flex>
);
